<template>
    <FormSection
        title="Evacuation"
        :full-height="false"
        :application-id="application"
        :type="`${isHisSection ? 'his-section' : 'default-section'}`"
    >
        <template #content>
            <div class="row p-2">
                <div class="row g-0 col-12 offset-lg-1 col-lg-10">
                    <div class="form-group col-12 col-lg-4 pe-lg-2 w-30">
                        <label for="evacuation-email"> Evacuation Zone </label>
                        <select class="form-select" v-model="patient.evacuationZone">
                            <option :value="0">Select Evacuation Zone</option>
                            <option
                                v-for="[index, zone] in enumToMap(evacuationZoneEnum)"
                                :key="zone.value"
                                :value="zone.value"
                            >
                                {{ zone.name }}
                            </option>
                        </select>
                    </div>
                    <div class="col-12 row g-0">
                        <div class="form-group col-12 col-lg-5 pe-lg-2">
                            <label for="evacuation-primary-phone"> Primary Phone Number </label>
                            <PhoneNumber
                                :enable-country="true"
                                v-model:value="patient.evacuationPrimaryPhoneNumber.number"
                                v-model:extension="patient.evacuationPrimaryPhoneNumber.extension"
                                v-model:type="patient.evacuationPrimaryPhoneNumber.type"
                                :phone-type-options="phoneNumberOptions"
                                v-model:country="patient.evacuationPrimaryPhoneNumber.country"
                                v-number-only
                            />
                        </div>
                        <div class="form-group col-12 col-lg-5 pe-lg-2">
                            <label for="evacuation-alternate-phone"> Alternate Phone Number </label>
                            <PhoneNumber
                                :enable-country="true"
                                v-model:value="patient.evacuationAlternatePhoneNumber.number"
                                v-model:extension="patient.evacuationAlternatePhoneNumber.extension"
                                v-model:type="patient.evacuationAlternatePhoneNumber.type"
                                :phone-type-options="phoneNumberOptions"
                                v-model:country="patient.evacuationAlternatePhoneNumber.country"
                                v-number-only
                            />
                        </div>
                    </div>
                    <div class="w-100"></div>
                    <div class="col-12 form-group">
                        <div class="form-check custom-checkbox form-check-inline mt-2">
                            <input
                                type="checkbox"
                                id="same-emergency-contact"
                                class="form-check-input au-target"
                                v-model="isEvacuationAddressSameAsEmergencyContact"
                            />
                            <label class="form-check-label" for="same-emergency-contact">
                                <span class="me-1">Same as Primary Emergency Contact</span>
                            </label>
                        </div>
                    </div>
                    <div class="col-12 col-lg-10">
                        <AddressForm
                            address-type="evacuationAddress"
                            :address="patient.evacuationAddress"
                            :application="patient.application"
                            :account-id="accountId"
                            :is-facility="false"
                            :is-required="isRequired"
                            :show-code="false"
                            :is-primary-address="false"
                            :disable-inputs="disableInputs"
                        />
                    </div>
                </div>
            </div>
        </template>
    </FormSection>
</template>

<script src="./EvacuationSection.ts"></script>
